"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareItemClick = exports.Name = void 0;
const Name = exports.Name = 'share-item-click';
const ShareItemClick = exports.ShareItemClick = Name;
